import React, { useState } from 'react'
import '../Style/Account_Com.css'
import User_Picture from '../Profile_Pictures/1662741205554.jpg'
import CalenderIcon from '../Logos/calendar.svg'
import PenIcon from '../Logos/pen-tool.svg'
import LinkIcon from '../Logos/external-link.svg'
import EyeIcon from '../Logos/eye.svg'
import RemoveIcon from '../Logos/subtract-circle-minus-remove.svg'
import EditIcon from '../Logos/edit-write.svg'
import EmailIcon from '../Logos/envelope.svg'
import { Link } from 'react-router-dom'

function AccountComponent(Account_Data) {
    const [AccountData, SetAccountData] = useState(Account_Data.Account_Data)
    return (
        <>
            <div className='manage-site-accounts-container'>
                <div className='section_control'>
                    <div className='remove-account'>
                        <img src={RemoveIcon} />
                        <div className='hover'>حذف</div>
                    </div>
                </div>
                <div className='section_info'>
                    <div className='important-information-container'>
                        <div className='name-of-account'>{AccountData && AccountData.username ? AccountData.username : null}</div>
                        <div className='user-email'>
                            <div className='text'>ایمیل: {AccountData && AccountData.email ? AccountData.email : "N/A"}</div>
                            <img src={EmailIcon} className='email-icon' />
                        </div>
                        <div className='user-phone'>
                            <div className='text'>شماره تلفن: {AccountData && AccountData.phone_number ? AccountData.phone_number : "N/A"}</div>
                            <img src={EmailIcon} className='phone-icon' />
                        </div>
                        <div className='created-date'>
                            <div className='text'>تاریخ ساخت حساب: {AccountData && AccountData.created_date ? AccountData.created_date : "N/A"}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                    </div>
                    <div className='user-picture' style={{ backgroundImage: `url(${User_Picture})` }}></div>
                </div>
            </div>
        </>
    )
}

export default AccountComponent